var exports = {
  "t_": "VoiceSceneStageEffects.module__confetti___cHYzb2",
  "fV": "VoiceSceneStageEffects.module__piece___cHYzb2",
  "s9": "VoiceSceneStageEffects.module__stageConfettiFall___cHYzb2",
  "RY": "VoiceSceneStageEffects.module__spot___cHYzb2",
  "X1": "VoiceSceneStageEffects.module__stageSpot___cHYzb2",
  "aT": "VoiceSceneStageEffects.module__beam___cHYzb2",
  "hN": "VoiceSceneStageEffects.module__ring___cHYzb2",
  "re": "VoiceSceneStageEffects.module__stageSpotFade___cHYzb2",
};

module.exports = exports;
